// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'styles/colors'
import { fontSize } from 'frontend_core/dist/styles/variables'

const TextArea = styled.p`
  color: ${Colors.black};
  font-size: ${props => props.fontSize || fontSize.small_3}px;
  line-height: 1.5;
  ${({ modal }) =>
    modal &&
    css`
      text-align: center;
      color: ${Colors.gray9};
      font-size: ${fontSize.small_2}px;
    `}
  ${({ notice }) =>
    notice &&
    css`
      color: ${Colors.red};
      font-size: ${fontSize.small}px;
      line-height: 1.5;
    `}
  ${({ desc }) =>
    desc &&
    css`
      color: ${Colors.gray9};
      font-size: ${fontSize.small}px;
      line-height: 1.4;
    `}
  ${props =>
    props.inlineBlock &&
    `
    display: inline-block;
  `}
  ${props =>
    props.bold &&
    `
    font-weight: bold;
  `}
  ${props =>
    props.verticalMiddle &&
    `
    vertical-align: middle;
  `}
`

type PropTypes = {
  modal?: boolean,
  notice?: boolean,
  desc?: boolean,
  inlineBlock?: boolean,
  fontSize?: number,
  bold?: boolean,
}

export default (props: PropTypes) => (
  <TextArea {...props}>{props.children}</TextArea>
)
